<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-tabs v-model="tabIndex" content-class="pt-3" lazy @input="onTab">
          <b-tab :title="$t('involved.crud.entities.tabs.person')">
            <base-crud
              :ref="'involvedsCrud'"
              :crudName="$t('involved.crud.title')"
              :newText="$t('involved.crud.newText')"
              :table="table"
              :columns="columns"
              :options="options"
              :endPoint="endPoint"
              :enableAdd="$hasAbility('envolvido.gerenciar')"
              :enableEdit="$hasAbility('envolvido.gerenciar')"
              :enableDelete="$hasAbility('envolvido.gerenciar')"
              :enableView="false"
              :enableReset="false"
              :dataForm="dataForm"
            >
            </base-crud>
          </b-tab>
          <b-tab v-for="type in entityTypes" :key="type" :title="$t(`involved.crud.entities.tabs.${type}`)">
            <base-crud
              :crudName="$t('involved.crud.title')"
              :newText="$t('involved.crud.newText')"
              :table="entityCruds[type].table"
              :columns="entityCruds[type].columns"
              :options="entityCruds[type].options"
              :endPoint="entityCruds[type].endPoint"
              :enableAdd="$hasAbility('envolvido.gerenciar')"
              :enableEdit="$hasAbility('envolvido.gerenciar')"
              :enableDelete="$hasAbility('envolvido.gerenciar')"
              :enableView="false"
              :enableReset="false"
            >
            </base-crud>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import { ENTITY_TYPES, entityCrudConfig } from "./entityFields";

export default {
  data: function () {
    const crud = this;
    const tabs = ["person", ...ENTITY_TYPES];
    return {
      entityTypes: ENTITY_TYPES,
      entityCruds: ENTITY_TYPES.reduce((all, type) => ({ ...all, [type]: entityCrudConfig(this, type) }), {}),
      tabIndex: Math.max(tabs.indexOf(this.$route.query.tab), 0),
      table: "involvedsTable",
      showMessageImport: false,
      involvedsCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "social_name", "status", "actions"],
      tableData: [
        "id",
        "name",
        "social_name",
        "cpf",
        "rg",
        "cns",
        "gender",
        "birth_date",
        "race",
        "telephone",
        "cellphone",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "social_name", "status"],
        sortable: ["id", "name"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('involved.crud.headings.id'),
          name: this.$t('involved.crud.headings.name'),
          social_name: this.$t('involved.crud.headings.socialName'),
          status: this.$t('common.status'),
          actions: this.$t('common.actions'),
        },

        texts: {
          filterBy: this.$t('involved.crud.filterBy'),
          defaultOption: this.$t('common.select'),
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: this.$t('common.active'),
            },
            {
              id: 0,
              text: this.$t('common.inactive'),
            },
          ],
        },
        templates: {
          status: (h, row, index) => {
            return row.status == 1
              ? this.$t('common.active')
              : row.status == 0
              ? this.$t('common.inactive')
              : this.$t('common.inactive');
          },

          social_name: (h, row, index) => {
            return row.social_name ? row.social_name : this.$t('involved.crud.notDefined');
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          // `crud` (e não $parent.$parent...) para não quebrar quando o CRUD muda de lugar na árvore (abas).
          let query = crud.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "involveds",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    // Guarda a aba na URL: voltar do formulário de edição reabre a mesma aba.
    onTab(index) {
      const tab = ["person", ...ENTITY_TYPES][index];
      if (this.$route.query.tab !== tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } }).catch(() => {});
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-involveds";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            self.$t('involved.messages.successTitle'),
            self.$t('involved.messages.importSuccess'),
            "success"
          );
          self.showMessageImport = true;
          self.$refs.involvedsCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            self.$t('involved.messages.importErrorTitle'),
            self.$t('involved.messages.importError'),
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        social_name: "social_name",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>